<template>
  <div class="view-wrap">
    <div class="view-content bg-regular">
      <section id="hero" class="standard-hero bg-blue">
        <div class="section-inner">
          <div class="tagline" :class="is.mac() ? 'apple' : 'no-apple'">
            <div v-if="is.mobile() || skipAutodownload">
              <h1>Download RememBear</h1>
            </div>
            <div v-else>
              <h1>Thanks for downloading a&nbsp;Bear</h1>
              <p>Your RememBear download should start automatically. If it doesn't, click your platform&nbsp;below</p>
            </div>
          </div>
          <div class="animation-wrap">
            <div v-if="is.ie()">
              <img class="animation retina-block" src="./images/bear-sitting-on-a-laptop@2x.png" alt="Cartoon black bear sitting on laptop">
              <img class="animation low-res" src="./images/bear-sitting-on-a-laptop.png" alt="Cartoon black bear sitting on laptop">
            </div>
            <div v-else class="animation" ref="heroAnimate"></div>
          </div>
        </div>
      </section>
      <section id="downloads">
        <div class="container">
          <div v-if="!is.mobile()" class="section-inner-md text-center">
            <div class="apps">
              <div class="row download-row">
                <div class="download-col col-xs-12 col-sm-6 app">
                  <a id="mac-dl" :href="external.downloadLinks.mac" download @click="downloaded = true" class="btn btn-lg dark-blue dl mac"><div>Mac</div></a>
                  <p class="fine-print">64-bit macOS 10.12 and later</p>
                </div>
                <div class="download-col col-xs-12 col-sm-6 app">
                  <a :href="external.downloadLinks.ios" class="btn btn-lg dark-blue dl ios"><div>iOS</div></a>
                  <p class="fine-print">iPads and iPhones with iOS 11.2 and&nbsp;later</p>
                </div>
              </div>
              <div class="row download-row">
                <div class="download-col col-xs-12 col-sm-6 app">
                  <a id="pc-dl" :href="win64 || is.mac() ? external.downloadLinks.windows64 : external.downloadLinks.windows32" download @click="downloaded = true" class="btn btn-lg dark-blue dl windows"><div>Windows</div></a>
                  <p v-if="win64 || is.mac()" class="fine-print">64&#8209;bit Windows 10 and later. Looking for the <a :href="external.downloadLinks.windows32" download>32&#8209;bit&nbsp;version</a>?</p>
                  <p v-else class="fine-print">32&#8209;bit Windows 10 and later. Looking for the <a :href="external.downloadLinks.windows64" download>64&#8209;bit&nbsp;version</a>?</p>
                </div>
                <div class="download-col col-xs-12 col-sm-6 app">
                  <a :href="external.downloadLinks.android" class="btn btn-lg dark-blue dl android"><div>Android</div></a>
                  <p class="fine-print">Android 5.0 and&nbsp;later</p>
                </div>
              </div>
            </div>
            <div class="text-center">
              <div class="copy">
                <h2>Browser extensions</h2>
                <p>Combine RememBear with the browser extension to autofill your logins and credit cards with one click</p>
              </div>
              <div class="row">
                <div class="col-12">
                  <div class="browsers">
                    <div class="browser">
                      <a class="btn btn-lg grey chrome-btn" :href="external.downloadLinks.chrome"><div>Chrome</div></a>
                      <p class="fine-print">Chrome Browser 22+ on Windows &&nbsp;macOS</p>
                    </div>
                    <div class="browser">
                      <a class="btn btn-lg grey firefox-btn" :href="external.downloadLinks.firefox"><div>Firefox</div></a>
                      <p class="fine-print">Firefox Browser 57+ on Windows &&nbsp;macOS</p>
                    </div>
                  </div>
                </div>
              </div>
              <div class="safari-notice">
                <p><strong>Safari user?</strong></p>
                <p>RememBear for Safari is automatically installed with the&nbsp;Mac&nbsp;app.</p>
                <p class="fine-print">Requirements: Safari Browser 11+ on macOS</p>
              </div>
              <div class="notices">
                <router-link :to="{ name: 'notices'}" class="fine-print">Notice and Attribution</router-link>
                <a href="https://help.remembear.com/hc/en-us/articles/360006847152" class="fine-print">Uninstall Remembear</a>
              </div>
            </div>
          </div>
        </div>
        <div v-if="is.mobile()" class="mobile-cta">
          <div v-if="is.android()">
            <a class="playstore" :href="external.downloadLinks.android">
              <img src="../../images/google-play.svg" alt="Get it on Google Play">
            </a>
            <p class="fine-print">Android 5.0 and later</p>
          </div>
          <div v-else>
            <a class="appstore" :href="external.downloadLinks.ios">
              <img class="android" src="../../images/app-store.svg" alt="Download on the App Store">
            </a>
            <p class="fine-print">iPads and iPhones with iOS 11.2 and later</p>
          </div>
        </div>
      </section>
      <iframe id="download-frame" style="display:none;"></iframe>
    </div>
  </div>
</template>

<script>
import bodymovin from 'bodymovin/build/player/bodymovin_light.min.js'
import Cookies from 'js-cookie'
import is from 'is_js'

export default {
  name: 'download',
  data () {
    return {
      is: is,
      win64: navigator.userAgent.indexOf('WOW64') !== -1 ||
             navigator.userAgent.indexOf('Win64') !== -1,
      animation: {},
      downloaded: false
    }
  },
  computed: {
    skipAutodownload: function () {
      return this.ENV.name !== 'production' || Cookies.get('downloaded') || is.mobile()
    }
  },
  beforeMount: function () {
    this.$emit('modifyLayout', {
      bgColor: 'bg-blue'
    })
  },
  methods: {
    play: function (delay) {
      if (delay) {
        setTimeout(() => {
          this.animation.play()
        }, delay)
      } else {
        this.animation.play()
      }
    },
    autoDownload: function () {
      if (this.skipAutodownload) {
        return
      }
      if (is.mac()) {
        document.getElementById('download-frame').src = this.external.downloadLinks.mac
      } else if (is.windows()) {
        let frameSrc = this.external.downloadLinks.windows32
        if (this.win64) {
          frameSrc = this.external.downloadLinks.windows64
        }
        document.getElementById('download-frame').src = frameSrc
      }
      let time = new Date()
      time.setTime(time.getTime() + 1 * 3600 * 1000)
      Cookies.set('downloaded', true, {expires: time})
    }
  },
  mounted () {
    this.$nextTick(function () {
      this.animation = bodymovin.loadAnimation({
        container: this.$refs.heroAnimate,
        renderer: 'svg',
        loop: false,
        autoplay: false,
        path: '/static/animationData/download.json'
      })
      this.play(1000)
      setTimeout(() => {
        if (!this.downloaded) this.autoDownload()
      }, 2000)
    })
  }
}
</script>

<style scoped lang="stylus" src="./download.styl" >



// WEBPACK FOOTER //
// src/views/download/download.vue